export const routesTanitim = [
  {
    path: "/sube_tanitim",
    name: "sube_tanitim",
    component: () => import("@/views/sube/index.vue"),
    meta: {
      public: false,
      title: "Şube",
      yetki: { k: [1020002] },
    },
  },
]
